export default "__VITE_ASSET__k49igb0$__"